import { GameManager } from "./../../GameManager";
import { GameVars } from "../../GameVars";
import { BoardScene } from "./BoardScene";
import { BoardContainer } from "./BoardContainer";
import { GameConstants } from "../../GameConstants";

export class BoardManager {

    public static init(): void {
        
        GameVars.undoNum = 5;
        GameVars.selectedBallsContainer = -1;
        GameVars.paused = false;

        const levels = GameVars.currentScene.game.cache.json.get("levels");

        // clonamos el array
        GameVars.levelData = JSON.parse(JSON.stringify(levels[GameVars.difficulty]["level_" + GameVars.currentLevel]));
        GameVars.moves = [];
    }

    public static undo(): void {
    
        GameVars.undoNum --;

        let move = GameVars.moves.pop();

        BoardContainer.currentInstance.addBall(move.to, move.from);
        GameVars.levelData[move.from].unshift(GameVars.levelData[move.to].shift());

        GameVars.selectedBallsContainer = -1;
    }

    public static pauseGame(): void {

        GameVars.paused = true;

        BoardScene.currentInstance.showPauseLayer();
    }

    public static resumeGame(): void {

        GameVars.paused = false;

        BoardScene.currentInstance.hidePauseLayer();
    }

    public static onBallsContainerSelected(id: number, moving?: boolean): void {

        const balls = GameVars.levelData[id];

        if (GameVars.selectedBallsContainer === -1) {

           if (balls.length > 0) {

                BoardContainer.currentInstance.extractBall(id);
                GameVars.selectedBallsContainer = id;
            }

        } else {
            
            if (GameVars.selectedBallsContainer === id) {

                // la volvemos a meter de donde la hemos sacado
                BoardContainer.currentInstance.restituteBall(id);
                GameVars.selectedBallsContainer = -1;

            } else {

                // miramos si se puede poner
                const extractedBall = GameVars.levelData[GameVars.selectedBallsContainer][0];

                let upperBallInSelectedContainer: number;

                if (balls.length > 0) {
                    upperBallInSelectedContainer = balls[0];
                } else {
                    upperBallInSelectedContainer = null;
                }

                if ((upperBallInSelectedContainer === null || extractedBall === upperBallInSelectedContainer) && balls.length < 4) {

                    BoardContainer.currentInstance.addBall(GameVars.selectedBallsContainer, id);

                    let move = {from: GameVars.selectedBallsContainer, to: id};
                    GameVars.moves.push(move);

                    // actualizamos la matriz de las bolas
                    balls.unshift(GameVars.levelData[GameVars.selectedBallsContainer].shift());
                    
                    GameVars.selectedBallsContainer = -1;

                    if (BoardManager.isLevelCompleted()) {
                        BoardManager.onLevelCompleted();
                    }
                } else if (extractedBall !== upperBallInSelectedContainer || balls.length >= 4) {

                    if (!moving) {
                        BoardContainer.currentInstance.restituteBall(GameVars.selectedBallsContainer);
                        BoardContainer.currentInstance.extractBall(id);
                        GameVars.selectedBallsContainer = id;
                    } else {
                        BoardContainer.currentInstance.extractBall(GameVars.selectedBallsContainer);
                    }
                    
                }
            }
        }
    }

    private static onLevelCompleted(): void {

        GameVars.paused = true;

        switch (GameVars.difficulty) {

            case GameConstants.DIFFICULTY_EASY:
                if (GameVars.currentLevel > GameVars.gameData.achievedEasyLevel) {
                    GameVars.gameData.achievedEasyLevel = GameVars.currentLevel;
                }   
                break;
            case GameConstants.DIFFICULTY_NORMAL:
                if (GameVars.currentLevel > GameVars.gameData.achievedMediumLevel) {
                    GameVars.gameData.achievedMediumLevel = GameVars.currentLevel;
                }
                break;
            case GameConstants.DIFFICULTY_HERO:
                if (GameVars.currentLevel > GameVars.gameData.achievedDifficultLevel) {
                    GameVars.gameData.achievedDifficultLevel = GameVars.currentLevel;
                }
                break;
            default:
        }

        GameManager.writeGameData();
        
        BoardScene.currentInstance.onLevelCompleted();
    }

    private static isLevelCompleted(): boolean {

        let ret = true;

        for (let i = 0; i < GameVars.levelData.length; i ++) {

            const container = GameVars.levelData[i];

            if (container.length === 0) {
                continue;
            }

            if (container.length !== 4) {
                ret = false;
                break;
            }

            // para comprobar si todos los valores del array son iguales
            const allEqual = container.every(v => v === container[0]);

            if (!allEqual) {
                ret = false;
                break;
            }
        }

        return ret;
    }
}
